module.exports = __webpack_public_path__ + "img/new-foto (8).5be0ce22.jpg";